module.exports = __webpack_public_path__ + "img/yaoqing_bg.6794f130.png";